<template>
  <container>
    <div class="w-full flex flex-col mt-16">
      <title-component title="Descubra se este tratamento é para você"
                       sub-title="A Dra. Bianca Eluisa é pioneira no tratamento das Fáscias no Estado do Paraná."
      />
      <div class="w-full flex flex-col justify-between items-center mx-auto lg:gap-y-4">
        <!--inicio do card-->
        <div class="w-full flex flex-col lg:flex-row justify-center items-center mt-8">
          <div class="w-full lg:w-6/12">
            <img src="../../../public/21386.webp" width="500" height="334" alt="Fascias" loading="lazy" class="rounded-lg"/>
          </div>
          <div
              class="w-full lg:w-6/12 mt-4 lg:mt-0 flex flex-col justify-center items-center mb-4 md:mb-0 gap-y-4 rounded-md lg:ml-12">
            <div
                class="bg-gradient-to-r from-[#00BADE] to-[#00DFDE] flex flex-col p-8 justify-start gap-x-4
                 items-center text-white shadow-2xl rounded-2xl">
              <h2 class="text-2xl font-bold mb-4">
                Para você que pratica atividade física
              </h2>
              <p class="mb-4 text-lg">
                Para quem pratica atividade física e não pode parar, a recuperação rápida é essencial para alcançar seus
                objetivos. Com um tratamento eficaz, você reduz dores, evita lesões e mantém seu desempenho sem
                interrupções.
              </p>
              <primary-button title="Agende sua consulta"/>
            </div>
          </div>
        </div>
        <!-- fim do card-->

        <!--inicio do card-->
        <div class="w-full flex flex-col lg:flex-row justify-center items-center mt-8">
          <div class="order-2 lg:order-1 w-full lg:w-6/12">
            <div
                class="bg-gradient-to-r from-[#00BADE] to-[#00DFDE] flex flex-col p-8 justify-start gap-x-4
                 items-center text-white shadow-2xl rounded-2xl">
              <h2 class="text-2xl font-bold mb-4">
                Para você que sente dores crônicas
              </h2>
              <p class="mb-4 text-lg">
                Sentir dor e ainda precisar trabalhar é desafiador. Tomar remédios que demoram a fazer efeito e trazem
                efeitos colaterais pode ser frustrante. Você merece um tratamento que alivie sua dor de forma rápida,
                eficaz e sem causar desconfortos adicionais.
              </p>
              <primary-button title="Agende sua consulta"/>
            </div>
          </div>
          <div
              class="order-1 lg:order-2 w-full lg:w-6/12 flex flex-col justify-center items-center mb-4 md:mb-0 gap-y-4 rounded-md lg:ml-12">
            <img src="../../../public/50380.webp" width="500" height="334" alt="Fascias" loading="lazy"  class="rounded-lg"/>

          </div>
        </div>
        <!-- fim do card-->

        <!--inicio do card-->
        <div class="w-full flex flex-col lg:flex-row justify-center items-center mt-8">
          <div class="w-full lg:w-6/12">
            <img src="../../../public/3183.webp" width="500" height="358" alt="Fascias" loading="lazy" class="rounded-lg"/>
          </div>
          <div
              class="w-full lg:w-6/12 flex flex-col justify-center items-center mt-4 lg:mt-0 mb-4 md:mb-0 gap-y-4 rounded-md lg:ml-12">
            <div
                class="bg-gradient-to-r from-[#00BADE] to-[#00DFDE] flex flex-col p-8 justify-start gap-x-4
                 items-center text-white shadow-2xl rounded-2xl">
              <h2 class="text-2xl font-bold mb-4">
                Para você que está com movimento travado
              </h2>
              <p class="mb-4 text-lg">
                Se tarefas simples como pegar seu filho no colo, limpar a casa ou dormir bem se tornaram difíceis, é
                hora de agir. Um tratamento eficaz avalia e trata a raiz do problema, devolvendo sua liberdade sem medo
                de novas dores.
              </p>
              <primary-button title="Agende sua consulta"/>
            </div>
          </div>
        </div>
        <!-- fim do card-->
      </div>
    </div>
  </container>
</template>
<script>
import Container from "@/components/partials/Container.vue";
import TitleComponent from "@/components/TitleComponent.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";

export default {
  name: 'FasciaComponent',
  components: {
    PrimaryButton,
    TitleComponent,
    Container,
  }
}
</script>